/**
 * ServicesStore
 * Extends the BaseStore for managing Services.
 */

import BaseStore from '@legacy-src/Datastores/BaseStore';
import { ServiceInterface } from "@sah/Classes/Service";

class ServicesStore extends BaseStore<ServiceInterface> {
    // Services use the legacy SYSID primary key name
    constructor(primary_key_name: string = 'SYSID') {
        super(primary_key_name);
    }
}

export default new ServicesStore();
